<template>
  <div class="god_page_container">
    <div class="page-title-row">
      <div>
        <h2 style="margin-bottom: 0px;">Gestión de Planes</h2>
        <span v-if="draftPlans.length > 0" class="badge badge-warning" style="margin-top: 0px;">Hay {{ draftPlans.length }} planes en borrador</span>
        <span v-if="plans.filter(p => p.tiene_productos_en_revision).length > 0" class="badge badge-warning" style="margin-top: 0px;">Hay planes con productos en borrador</span>
      </div>
      <button @click="addPlan()" class="main_button-green">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        Crear nuevo plan
      </button>
    </div>

    <div id="selector_container">
      <select 
        v-model="modo"
        @change="getAllPlans()"
        class="input_200">
        <option value="0">Planes vigentes</option>
        <option value="1">Planes caducados</option>
        <option value="2">Planes eliminados</option>
        <option value="3">Planes en borrador</option>
      </select>

      <select 
        v-model="tipo"
        class="input_200"
        :disabled="modo ==='3'">
        <option value="0">Plan de profesional</option>
        <option value="1">Plan de particular</option>
        <option value="2">Tarjeta regalo</option>
      </select>

      <input
        type="text"
        class="input_200"
        v-model="planId"
        placeholder="ID del plan"
        :disabled="modo ==='3'"
      />

      <input
        type="text"
        class="input_200"
        v-model="planTitle"
        placeholder="Título del plan"
        :disabled="modo ==='3'"
      />

      <input
        type="text"
        class="input_200"
        v-model="companyName"
        placeholder="Nombre de la empresa"
        :disabled="modo ==='3'"
      />

      <input
        type="date"
        v-model="planDate"
        class="input_200"
        placeholder="Fecha del plan"
        :disabled="modo ==='3'"
      />

      <select 
        v-model="ciudad"
        class="input_200"
        :style="{ color: ciudad === '' ? 'var(--text-color-placeholder)' : '' }"
        :disabled="modo ==='3'">
        <option value="">Ciudad</option>
        <option value="Donosti">Donosti</option>
        <option value="Logroño">Logroño</option>
        <option value="Madrid">Madrid</option>
        <option value="Pamplona">Pamplona</option>
        <option value="Pirineo Aragones">Pirineo Aragonés</option>
        <option value="Valencia">Valencia</option>
        <option value="Zaragoza">Zaragoza</option>
      </select>
    </div>

    <div class="table-container">
      <table v-if="modo !== '3'">
        <thead>
          <tr>
              <th class="small sortable-th" @click="setSort('ciudad')">Ciudad</th>
              <th class="small sortable-th" @click="setSort('id')">Id del Plan</th>
              <th class="small">Tipo</th>
              <th class="big sortable-th" @click="setSort('titulo')">Título</th>
              <th class="small sortable-th" @click="setSort('fecha_fin')">Fecha fin</th>
              <th class="small sortable-th" @click="setSort('fecha_validez')">Canjeable hasta</th>
              <th class="big sortable-th" @click="setSort('empresa')">Empresa</th>
              <th class="small">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(item, index) in plans
            .filter(plan => {
              let estado;
              if (modo === '0') estado = 'vigente';
              else if (modo === '1') estado = 'caducado';
              else if (modo === '2') estado = 'cancelado';

              let filterTipo;
              if (tipo === '0') filterTipo = 'promo';
              else if (tipo === '1') filterTipo = 'plan';
              else if (tipo === '2') filterTipo = 'gift_card';

              return (plan.titulo.toLowerCase().includes(planTitle.toLowerCase()) || planTitle === '') &&
                    (plan.empresa.toLowerCase().includes(companyName.toLowerCase()) || companyName === '') &&
                    (plan.id.toString().toLowerCase().includes(planId.toLowerCase()) || planId === '') &&
                    (plan.ciudad.toLowerCase().includes(ciudad.toLowerCase()) || ciudad === '') &&
                    (fechaExiste(plan.fechas, planDate) || planDate === '') &&
                    plan.tipo === filterTipo &&
                    plan.estado === estado;
            }).sort((a, b) => {
              let modifier = 1;
              if (sortDirection === 'desc') modifier = -1;
              if (sortColumn === 'fecha_fin' || sortColumn === 'fecha_validez') {
                const [diaA, mesA, anioA] = a[sortColumn].split('/').map(Number);
                const [diaB, mesB, anioB] = b[sortColumn].split('/').map(Number);
                const dateA = new Date(anioA, mesA - 1, diaA);
                const dateB = new Date(anioB, mesB - 1, diaB);
                if (dateA < dateB) return -1 * modifier;
                if (dateA > dateB) return 1 * modifier;
                return 0;
              } else {
                if (a[sortColumn] < b[sortColumn]) return -1 * modifier;
                if (a[sortColumn] > b[sortColumn]) return 1 * modifier;
                return 0;
              }
            })"
            :key="item.id"
            :class="item.tiene_productos_en_revision ? 'bg-yellow' : index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
          >
            <td>{{ item.ciudad }}</td>
            <td><strong>#{{ item.id }}</strong></td>
            <td>
              <span class="badge badge-neutral">{{ traducirTipo(item.tipo, item.flash) }}</span>
            </td>
            <td style="text-align: left; font-weight: 500;">{{ item.titulo }}</td>
            <td>
              <span v-if="esFechaProxima(item.fecha_fin) && modo === '0'" class="badge badge-danger">
                🚨 {{ item.fecha_fin }}
              </span>
              <span v-else>{{ item.fecha_fin }}</span>
            </td>
            <td>{{ item.fecha_validez }}</td>
            <td>{{ item.empresa }}</td>
            <td>
              <div class="actions-cell">
                <img class="action_icon" title="Ver" src="@/assets/images/ic_reservation_visit.png" @click="onVisitClicked(item)"/>
                <img class="action_icon" title="Editar" src="@/assets/images/ic_reservation_edit.png" @click="onEditClicked(item)"/>
                <img v-if="item.tipo !== 'gift_card'" title="Participantes" class="action_icon" src="@/assets/images/ic_action_participants.png" @click="onParticipantsClicked(item)"/>
                <img v-if="item.tipo === 'promo' || item.tipo === 'gift_card'" title="Clonar" class="action_icon" src="@/assets/images/ic_action_clone.png" @click="onCloneClicked(item)"/>
                <img v-if="item.tipo === 'plan'" title="Comentarios" class="action_icon" src="@/assets/images/ic_action_comments.png" @click="onCommentsClicked(item)"/>
                <img class="action_icon" title="Eliminar / Desactivar" src="@/assets/images/ic_action_delete.png" @click="onHideClicked(item)"/>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table v-if="modo === '3'">
        <thead>
          <tr>
              <th class="big" @click="setSort('name')">Título</th>
              <th class="small" @click="setSort('company')">Empresa</th>
              <th class="small">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(item) in draftPlans
              .sort((a, b) => {
              let modifier = 1;
              if (sortDirection === 'desc') modifier = -1;
              if (a[sortColumn] < b[sortColumn]) return -1 * modifier;
              if (a[sortColumn] > b[sortColumn]) return 1 * modifier;
              return 0;
            })"
            :key="item.id"
            class="bg-yellow"
          >
            <td>{{ item.name }}</td>
            <td>{{ item.company }}</td>
            <td>
              <img class="action_icon" src="@/assets/images/ic_eye.png" @click="onDraftPlanDetailsClicked(item)"/>
              <img class="action_icon" src="@/assets/images/ic_action_delete.png" @click="onDeleteDraftPlanClicked(item)"/>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    <PlanParticularDetailsPopup
      :plan="selectedParticularPlanDetails" 
      @planParticularChanged="onParticularPlanChanged"
      @planParticularDetailsPopupCancelled="onPlanParticularDetailsPopupCancelled"
      @planParticularDetailsErrorHappened="onPlanParticularDetailsErrorHappened"
      />

    <PlanParticularParticipantsPopup
      :planName="selectedParticularPlanParticipantsName"
      :planId="selectedParticularPlanParticipantsId"
      :participants="selectedParticularPlanParticipants" 
      />

    <PlanParticularCommentsPopup
      :planName="selectedParticularPlanCommentsName"
      :planId="selectedParticularPlanCommentsId"
      :comments="selectedParticularPlanComments" 
      />

    <PlanDetailsPopup
      :plan="selectedPlanDetails"
      @planChanged="onPlanChanged"
      @planDetailsPopupCancelled="onPlanDetailsPopupCancelled"
      @planDetailsErrorHappened="onPlanDetailsErrorHappened"
      />

    <DraftPlanDetailsPopup
      :plan="selectedDraftPlanDetails"
      @draftPlanDetailsPopupCancelled="onDraftPlanDetailsPopupCancelled"
      @draftPlanDetailsErrorHappened="onDraftPlanDetailsErrorHappened"
      @createPlanSelected="onCreatePlanFromDraftSelected"
      />

    <TwoButtonPopup
      :title="twoButtonTitle"
      :message="twoButtonMessage"
      :acceptButton="twoButtonAcceptButton"
      @acceptCallback="() => twoButtonConfirmed()"
      :cancelButton="twoButtonCancelButton"
      @cancelCallback="() => twoButtonCancelled()"
      />

    <ErrorPopup :errorMessage="error" />

  </div>
</template>

<script setup>
  import { ref, nextTick, watch } from 'vue'
  import { useLoadingStore } from "@/stores/loadingStore";
  import { useRouter, useRoute } from 'vue-router';
  import { refreshToken } from "@/services/authService";
  import ErrorPopup from "@/components/common/ErrorPopup.vue";
  import PlanDetailsPopup from "@/components/plans/PlanDetailsPopup.vue";
  import TwoButtonPopup from "@/components/common/TwoButtonPopup.vue";
  import PlanParticularDetailsPopup from './PlanParticularDetailsPopup.vue';
  import PlanParticularParticipantsPopup from './PlanParticularParticipantsPopup.vue';
  import PlanParticularCommentsPopup from './PlanParticularCommentsPopup.vue';
  import DraftPlanDetailsPopup from './DraftPlanDetailsPopup.vue';
  
  const error = ref(null);
  const plans = ref([]);
  const draftPlans = ref([]);
  const loadingStore = useLoadingStore();
  const router = useRouter();
  const route = useRoute();

  const modo = ref(route.query.modo || '0');
  const tipo = ref(route.query.tipo || '0');
  const ciudad = ref(route.query.ciudad || '');
  const planTitle = ref(route.query.planTitle || '');
  const planId = ref(route.query.planId || '');
  const planDate = ref(route.query.planDate || '');
  const companyName = ref(route.query.companyName || '');
  const selectedPlanDetails = ref(null);
  const selectedDraftPlanDetails = ref(null);
  const selectedParticularPlanDetails = ref(null);
  const selectedParticularPlanCommentsName = ref("");
  const selectedParticularPlanCommentsId = ref(0);
  const selectedParticularPlanComments = ref(null);
  const selectedParticularPlanParticipantsName = ref("");
  const selectedParticularPlanParticipantsId = ref(0);
  const selectedParticularPlanParticipants = ref(null);

  const twoButtonTitle = ref("");
  const twoButtonMessage = ref("");
  const twoButtonAcceptButton = ref("");
  const twoButtonCancelButton = ref("");
  let twoButtonConfirmed = null;
  let twoButtonCancelled = null;
  
  const sortColumn = ref(route.query.sortColumn || 'fecha_fin');
  const sortDirection = ref(route.query.sortDirection || 'asc');

  watch([modo, tipo, ciudad, planTitle, planId, planDate, companyName, sortColumn, sortDirection], () => {
    router.replace({
      query: {
        ...route.query,
        modo: modo.value,
        tipo: tipo.value,
        ciudad: ciudad.value,
        planTitle: planTitle.value,
        planId: planId.value,
        planDate: planDate.value,
        companyName: companyName.value,
        sortColumn: sortColumn.value,
        sortDirection: sortDirection.value,
      }
    });
  });

  const getDraftPlans = async (showLoading) => {
    if (showLoading) {
      loadingStore.setLoading(true);
    }
    try {
      let response = await getDraftPlansInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getDraftPlansInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      if (data.errors) {
        return;
      }

      draftPlans.value = data.datos;
    } catch (err) {
      console.log(err);
    } finally {
      if (showLoading) {
        loadingStore.setLoading(false);
      }
    }
  };

  const getAllPlans = async () => {
    if (modo.value === '3') return;
    
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getAllPlansInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getAllPlansInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error obteniendo los planes.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
        plans.value = [];
      } else {
        error.value = null;
        plans.value = data.planes;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  };

  const setSort = (column) => {
    if (sortColumn.value === column) {
      sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
    } else {
      sortColumn.value = column;
      sortDirection.value = 'asc';
    }
  };

  async function getAllPlansInAPI() {
    let status;
    if (modo.value === '0') status = 'vigente';
    else if (modo.value === '1') status = 'caducado';
    else if (modo.value === '2') status = 'cancelado';

    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/get?user_id="+localStorage.getItem('user_id')+"&status="+status, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  async function getDraftPlansInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/drafts/get?user_id="+localStorage.getItem('user_id'), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  const showError = async (message) => {
    error.value = null;
    await nextTick(); // Espera a que Vue reaccione al cambio
    error.value = message;
  };

  function traducirTipo(tipo, isFlash) {
    switch (tipo) {
      case 'plan':
        return 'Particular';
      case 'promo':
        if (isFlash) {
          return "⚡️Profesional⚡️"
        } else {
          return 'Profesional';
        }
      case 'gift_card':
        return 'Tarjeta regalo';
      default:
        return tipo;
    }
  }

  function esFechaProxima(fechaStr) {
    const [dia, mes, anio] = fechaStr.split('/').map(Number)
    const fecha = new Date(anio, mes - 1, dia) // Mes empieza en 0 (enero)

    const hoy = new Date()
    hoy.setHours(0, 0, 0, 0) // Opcional: quitar horas para comparación solo por fecha

    const unaSemanaDespues = new Date(hoy)
    unaSemanaDespues.setDate(hoy.getDate() + 7)

    return fecha <= unaSemanaDespues
  }

  const onVisitClicked = (item) => {
    if (item.url) {
      window.open(item.url, '_blank');
    }
  };

  const onEditClicked = (item) => {
    getPlanDetails(item.id, item.tipo === 'promo' || item.tipo === 'gift_card', "edit");
  };

  const onParticipantsClicked = (item) => {
    if (item.tipo === 'promo') {
      router.push({ name: 'Reservations', query: { planId: item.id, planDate: planDate.value } });
    } else {
      getPlanDetails(item.id, false, "participants");
    }
  };

  const onCloneClicked = (item) => {
    getPlanDetails(item.id, true, "clone");
  }

  const onCommentsClicked = (item) => {
    getPlanDetails(item.id, false, "comments");
  };

  const onHideClicked = async (item) => {
    twoButtonTitle.value = item.estado === 'cancelado' ? "Mostrar plan" : "Ocultar plan";
    twoButtonMessage.value = item.estado === 'cancelado' ? "¿Estás seguro de que deseas mostrar este plan?" : "¿Estás seguro de que deseas ocultar este plan?";
    twoButtonAcceptButton.value = "Aceptar";
    twoButtonCancelButton.value = "Cancelar";
    if (item.estado !== 'cancelado' && item.tiene_participantes) {
      twoButtonMessage.value += "\n\n🚨🚨Este plan tiene participantes.🚨🚨";
    }
    twoButtonConfirmed = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
      changePlanVisibilityConfirmed(item);
    };
    twoButtonCancelled = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
    }
  }

  const changePlanVisibilityConfirmed = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await changePlanVisibilityInAPI(item);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await changePlanVisibilityInAPI(item);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cambiando el estado del plan.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
      } else {
        error.value = null;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      getAllPlans();
    }
  };

  const changePlanVisibilityInAPI = async (item) => {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/edit_visibility", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
        body: JSON.stringify({
          "user_id": localStorage.getItem('user_id'),
          "plan_id": item.id,
          "visibility": item.estado === 'cancelado' ? 1 : 0 
        }),
      });
  };

  const getPlanDetails = async (itemId, isPromo, action) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getPlanDetailsInAPI(itemId);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getPlanDetailsInAPI(itemId);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cargando la información del plan.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        showError(data.message);
        plans.value = [];
      } else if (isPromo) {
        error.value = null;
        if (action == "clone") {
          data.plan.id_promo = 0;
          data.plan.campos_pedir.forEach(item => {
            item.id_campo = 0;
          });
          data.plan.productos.forEach(item => {
            item.id_producto_promo = 0;
            item.id_promo = 0;
            item.tiene_participantes = false;
          });
        }
        selectedPlanDetails.value = data.plan;
      } else if (action == "participants") {
        selectedParticularPlanParticipantsName.value = data.plan.nombre;
        selectedParticularPlanParticipantsId.value = data.plan.id_plan;
        selectedParticularPlanParticipants.value = data.plan.participantes;
      } else if (action == "comments") {
        selectedParticularPlanCommentsName.value = data.plan.nombre;
        selectedParticularPlanCommentsId.value = data.plan.id_plan;
        selectedParticularPlanComments.value = data.plan.comentarios;
      } else {
        selectedParticularPlanDetails.value = data.plan;
      }
    } catch (exception) {
      showError(exception.message);
    } finally {
      loadingStore.setLoading(false);
    }
  };

  const getPlanDetailsInAPI = async (itemId)=> {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/get_details?user_id="+localStorage.getItem('user_id')+"&plan_id="+itemId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        }
      });
  };

  const onPlanDetailsPopupCancelled = () => {
    selectedPlanDetails.value = null;
  };

  const onDraftPlanDetailsPopupCancelled = () => {
    selectedDraftPlanDetails.value = null;
  };

  const onPlanParticularDetailsPopupCancelled = () => {
    selectedParticularPlanDetails.value = null;
  };
  
  const onPlanDetailsErrorHappened = (message) => {
    showError(message);
  }

  const onDraftPlanDetailsErrorHappened = (message) => {
    showError(message);
  }

  const onPlanParticularDetailsErrorHappened = (message) => {
    showError(message);
  }

  const onPlanChanged = () => {
    selectedPlanDetails.value = null;
    getAllPlans();
  }

  const onParticularPlanChanged = () => {
    selectedParticularPlanDetails.value = null;
    getAllPlans();
  }

  const addPlan = () => {
    selectedPlanDetails.value = {
        "id_promo": 0,
        "nombre": "",
        "nombre_web": "",
        "descripcion": "",
        "etiqueta": "",
        "etiqueta_origen": "",
        "direccion": "",
        "online": false,
        "foto_video": "",
        "texto_boton": "",
        "enlace_boton": "",
        "tipo_boton": "",
        "categoria": "",
        "subcategoria_slug": "",
        "ciudad": "",
        "fecha_fin": "",
        "hora_fin": "",
        "flash": false,
        "fecha_validez": "",
        "tiene_datos": false,
        "descripcion_datos": "",
        "eliminado": true,
        "email_empresa": "",
        "orden": 0,
        "boton_pospago": "",
        "gastos_gestion_empresa": "0",
        "gastos_gestion_usuario": "0",
        "mostrar_cualquier_lugar": false,
        "descripcion_corta": "",
        "es_regalo": false,
        "texto_regalo": "",
        "fun_plan": false,
        "destacadisimo": false,
        "cantidad_obligatorios": 0,
        "etiqueta_personalizada": "",
        "envio_correo_confirmacion": false,
        "show_in_private_plans_page": false,
        "uso_cupon": false,
        "productos": [],
        "imagenes": [],
        "campos_pedir": [],
        "ciudad_key": "",
        "festivos": "",
        "otros_items": "",
        "otras_categorias": [],
        "seo_robots": "",
        "seo_canonical": "",
        "seo_json_data": "",
        "seo_keywords": "",
        "privacidad_url": ""
    }
  }

  const fechaExiste = (fechas, planDate) => {
    if (!Array.isArray(fechas) || !planDate) return false;

    const partes = planDate.split('-');
    if (partes.length === 3) {
      const [anio, mes, dia] = partes;
      const fechaPromo = `${dia}-${mes}-${anio}`;
      const fechaPlan = `${dia}/${mes}/${anio}`;
      return fechas.includes(planDate) || fechas.includes(fechaPromo) || fechas.includes(fechaPlan);
    }

    return fechas.includes(planDate);
  };

  const onDraftPlanDetailsClicked = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getDraftPlanDetailsInAPI(item, 0);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getDraftPlanDetailsInAPI(item, 0);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cargando los detalles del borrador.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
      } else {
        selectedDraftPlanDetails.value = data.datos;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  }

  const getDraftPlanDetailsInAPI = async (item, downloadPictures = 0) => {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/drafts/details?user_id="+localStorage.getItem('user_id')+"&plan_id="+item.id+"&download_pictures="+downloadPictures, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        }
      });
  };

  const onDeleteDraftPlanClicked = async (item) => {
    twoButtonTitle.value = "Eliminar borrador";
    twoButtonMessage.value = "¿Estás seguro de que deseas eliminar este borrador del plan generado por el partner?";
    twoButtonAcceptButton.value = "Aceptar";
    twoButtonCancelButton.value = "Cancelar";
    twoButtonConfirmed = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
      deleteDraftPlanConfirmed(item);
    };
    twoButtonCancelled = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
    }
  }

  const deleteDraftPlanConfirmed = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await deleteDraftPlanInAPI(item);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await deleteDraftPlanInAPI(item);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error eliminando el borrador.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
      } else {
        error.value = null;
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      getDraftPlans(true);
    }
  };

  const deleteDraftPlanInAPI = async (item) => {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/drafts/delete?user_id="+localStorage.getItem('user_id')+"&plan_id="+item.id, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        }
      });
  };
  
  const onCreatePlanFromDraftSelected = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await getDraftPlanDetailsInAPI(item, 1);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await getDraftPlanDetailsInAPI(item, 1);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cargando los detalles del borrador para la creación del plan final.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        error.value = data.message;
      } else {
        generateFinalPlan(data.datos);
      }
    } catch (exception) {
      error.value = exception.message;
    } finally {
      loadingStore.setLoading(false);
    }
  }

  const generateFinalPlan = async (draft) => {
    let imagenes_array = [];
    draft.images.forEach(image => {
      imagenes_array.push({"id_promocion": 0, "num_foto": image.num_image, "nombre": "image_"+image.num_image, "imagen_url": image.image_content });
    });

    let products_array = [];
    let expiration_date = draft.expiration_date;
    let endDate = draft.expiration_date;
    if (draft.dates != null && draft.dates.length > 0) {
      const datesArray = typeof draft.dates === 'string' ? JSON.parse(draft.dates) : draft.dates;
      const maxDate = new Date(Math.max(...datesArray.map(item => new Date(item.date))));
      maxDate.setDate(maxDate.getDate() + 10);
      expiration_date = maxDate.toISOString().split('T')[0];
      endDate = new Date(Math.max(...datesArray.map(item => new Date(item.date)))).toISOString().split('T')[0];
    
      datesArray.forEach((date, index) => {
        products_array.push({
          "id_producto_promo": -Math.floor(Math.random() * 10000) - (index + 1),
          "id_promocion": 0,
          "titulo": date.title,
          "precio": draft.price,
          "total": 0,
          "fecha": date.date,
          "hora": date.hour,
          "selec_minima": 1,
          "selec_maxima": 0,
          "stock_maximo": draft.capacity,
          "stock_actual": draft.capacity,
          "posicion": 0,
          "obligatorio": false,
          "email_empresa_opcional": "",
          "oculto": false,
          "forzar_completo": false,
          "draft": false
        });
      });
    } else {
        products_array.push({
          "id_producto_promo": -Math.floor(Math.random() * 10000) - 1,
          "id_promocion": 0,
          "titulo": "Producto 1",
          "precio": draft.price,
          "total": 0,
          "fecha": draft.expiration_date,
          "hora": "23:59",
          "selec_minima": 1,
          "selec_maxima": 0,
          "stock_maximo": draft.capacity,
          "stock_actual": draft.capacity,
          "posicion": 0,
          "obligatorio": false,
          "email_empresa_opcional": "",
          "oculto": false,
          "forzar_completo": false,
          "draft": false
        });
    }

    selectedPlanDetails.value = {
        "id_promo": 0,
        "nombre": draft.name,
        "nombre_web": draft.name,
        "descripcion": draft.description,
        "etiqueta": "",
        "etiqueta_origen": "",
        "direccion": "",
        "online": false,
        "foto_video": "",
        "texto_boton": "",
        "enlace_boton": "",
        "tipo_boton": "",
        "categoria": "",
        "subcategoria_slug": "",
        "ciudad": draft.city,
        "fecha_fin": endDate,
        "hora_fin": "23:59",
        "flash": false,
        "fecha_validez": expiration_date,
        "tiene_datos": false,
        "descripcion_datos": "",
        "eliminado": true,
        "email_empresa": draft.company_email,
        "orden": 0,
        "boton_pospago": "",
        "gastos_gestion_empresa": "0",
        "gastos_gestion_usuario": "0",
        "mostrar_cualquier_lugar": false,
        "descripcion_corta": "",
        "es_regalo": false,
        "texto_regalo": "",
        "fun_plan": false,
        "destacadisimo": false,
        "cantidad_obligatorios": 0,
        "etiqueta_personalizada": "",
        "envio_correo_confirmacion": false,
        "show_in_private_plans_page": false,
        "uso_cupon": false,
        "productos": products_array,
        "imagenes": imagenes_array,
        "campos_pedir": [],
        "ciudad_key": "",
        "festivos": "",
        "otros_items": "",
        "otras_categorias": [],
        "seo_robots": "",
        "seo_canonical": "",
        "seo_json_data": "",
        "seo_keywords": "",
        "privacidad_url": ""
    }
    
  }

  getDraftPlans(false);
  getAllPlans();

</script>

<style scoped>
.sortable-th {
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.sortable-th:hover {
  background-color: var(--gray-light);
}

.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex-wrap: nowrap;
}

.big {
  width: 22%;
}

.small {
  width: 10%;
}

@media (max-width: 768px) {
  #selector_container > * {
    flex: none !important;
    width: 100%;
  }

  .actions-cell {
    flex-wrap: wrap;
    gap: 6px;
  }
}
</style>
